module.exports = __webpack_public_path__ + "assets/images/stereo-02.96c65f6d6ace72aa0a65966fc4a1524e.svg";